<template>
  <el-dialog
    title="人员信息"
    :visible.sync="visible"
    width="960px"
    append-to-body
    @closed="handleClosed">
    <staff-table ref="table" />
    <div slot="footer">
      <el-button @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import StaffTable from '../../vendor-settings/busi/staff-table.vue'
// import CateEditModal from './cate-edit-modal.vue'
export default {
  name: 'StaffModal',
  components: { StaffTable },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      visible: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() { },
    fetch() {
      this.toggleModal(true)
      this.$nextTick(() => {
        this.$refs.table.handleCurrentChange(1)
      })
    }
  }
}
</script>
